import { render } from "./Topnav.vue?vue&type=template&id=1f4ec876&scoped=true&ts=true"
import script from "./Topnav.vue?vue&type=script&lang=ts"
export * from "./Topnav.vue?vue&type=script&lang=ts"

import "./Topnav.vue?vue&type=style&index=0&id=1f4ec876&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4ec876"]])

export default __exports__